import useBrand from 'hooks/useBrand';
import { TEMPO } from 'lib/constants';

const GraceRefund = ({ refund }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <div
      className={`${isTempo ? 'border-blue-90' : 'border-green-100'} border-black mx-4 -mt-10 rounded-lg border-t-[5px] border-solid bg-white-100 p-4 shadow-md`}
    >
      <p
        className={`text-primary ${isTempo ? 'font-dmSerif' : 'font-lemondecourrier'} text-3xl font-bold`}
      >
        {refund.amount}
      </p>
      <p className={'text-sm font-medium'}>will be refunded to your account</p>
    </div>
  );
};

GraceRefund.propTypes = {
  refund: PropTypes.exact({
    amount: PropTypes.string.isRequired,
    bodyCopy: PropTypes.string.isRequired,
  }),
};

export default GraceRefund;
